(function () {
	'use strict';

	angular
		.module('expo-cupom-digital')
		.controller('PrivacyController', PrivacyController)

	/** @ngInject */
	function PrivacyController() {
		const vm = this;



	}
}());